import { Component, Prop, Watch, Vue } from "vue-property-decorator";

@Component
export class StubInputBase extends Vue {
    @Prop() relatedElement: HTMLElement | undefined;

    focused = false;

    mounted() {
        document.addEventListener('click', this.clickOutsideHandler);
    }

    clickOutsideHandler(event: Event) {
        const el = this.$el as HTMLElement;
        const target = event.target as HTMLElement;
        const isClickInside = el.contains(target) || this.relatedElement?.contains(target);

        if (!isClickInside) {
            this.blur();
        }
    }

    focus() {
        this.focused = true;
    }

    blur() {
        this.focused = false;
    }

    @Watch('focused')
    watchFocused(focused: boolean) {
        if(focused) {
            this.$emit('focus')
        }
        else {
            this.$emit('blur')
        }
    }

    destroyed() {
        document.removeEventListener('click', this.clickOutsideHandler)
    }

    get expanded() {
        return this.focused;
    }

    get stubInputClassName(): { [classname: string]: boolean } {
        return {
            'input-stub': true
        }
    }

    get placeholderClassName() {
        return "input-stub__placeholder"
    }
}